export enum AppStructureActionType {
  FETCH_APP_STRUCTURE = "FETCH_APP_STRUCTURE",
  FETCH_APP_STRUCTURE_START = "FETCH_APP_STRUCTURE_START",
  FETCH_APP_STRUCTURE_SUCCESS = "FETCH_APP_STRUCTURE_SUCCESS",
  FETCH_APP_STRUCTURE_FAIL = "FETCH_APP_STRUCTURE_FAIL"
}
